import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.css']
})
export class LogoComponent {
  class: string = 'active';
  previewbol: boolean = false;
  outagebol: boolean = true;
  loading: boolean = false;
  showimage: boolean = false;
  url2: any;
  blob2:any;
  previewImage2: any;
  outageinputval: any = {};
  emails: any;
  statusAvailable: boolean = false;
  returndata: any;
  responseMessage: string = '';
  constructor(private http: HttpClient) {}

  preview(e: any) {
    e.preventDefault();
    this.previewbol = true;
    this.outagebol = false;
    console.log(this.outageinputval);
  }
  goback() {
    this.outagebol = true;
    this.previewbol = false;
  }

  sendemail(): void {
    this.getmethod();
  }

  image() {
    this.showimage = true;
  }
  getmethod() {
    // console.log(this.outageinputval.weblink)
    let formData = new FormData()
    formData.append("enterprise_image" , this.url2)
    this.loading = true;
    setTimeout(() => {
      console.log(1);
      // Call the setDelay function again with the remaining times
      this.loading = false;
    }, 2000);
    this.http
      .put(
        `https://mbvdevopsapi.maistering.com/iday/idayenterpriselogo`,
        formData
      )
      .subscribe({
        next: (data: any) => {
          this.statusAvailable = true;
          this.returndata = data['status_code'];
          if (this.returndata == 200) {
            this.responseMessage = ': Logo Updated Successfully!, Please go ahead & click on Purge below';
          } else {
            this.responseMessage = ': Logo Updated Successfully!, Please go ahead & click on Purge below';
          }
        },
        error: (err) => {
          this.statusAvailable = true;
          this.responseMessage = ': Oops...! Something Went Wrong!';
        },
        complete: () => {},
      });
  }

  onFileChanged2(e: any) {
    let reader:any = new FileReader();
    if (e.target.files && e.target.files.length > 0) {
      let file = e.target.files[0];
      this.url2= e.target.files[0];
      reader.readAsDataURL(file);
      reader.onload = () => {
        var data=reader?.result?.split(',')[1];
        var binaryBlob = atob(data);
        this.blob2 = binaryBlob;
        this.previewImage2 = reader.result;
      };
    }
  }

  onnclickpurge(){
    console.log("Button Purge")
    let URL = "https://mbvdevopsapi.maistering.com/iday/purge"
    this.http.post(URL, {}).subscribe(
      response => {
        this.statusAvailable = true;
        this.responseMessage = ': Profile Purged Successfully!, check profile after 5 minutes';
        console.log("Profile is Purged")
      },
      (err) => {
        this.statusAvailable = true;
        this.responseMessage = ': Oops...! Something Went Wrong!';
      },
    )
  }
}
